export function abortSignalToPromise(signal: AbortSignal): Promise<void> {
    return new Promise((_, reject) => {
        signal.addEventListener("abort", () => {
            reject(signal.reason);
        });
    });
}
